export default __webpack_public_path__ + "static/media/629.cc3ecf6c.png";